import { PropsWithChildren } from 'react';

import { useNavigate } from 'react-router';

import { useLocation, type NavigateFunction, Location } from 'react-router-dom';

import { getRoutesDirections } from '@/data/libraries/Routes';

import { useScreenSize, type ScreenSize } from '@/ui/hooks/useScreenSize';

import { Button, Col, Container, Image, Row } from 'react-bootstrap';

import ErrorImage from '@/ui/assets/ErrorImage';
import { useAppSelector } from '@/ui/store/helperRedux';
import { RootState } from '@/ui/store/store';
import { IStore } from '@/domain/interfaces/IStore';

import { translate } from '@/domain/utils/translate';

interface PropsDeclinedPayment {
  orderCode: string;
}

/** Interface de respuesta de fallido en transbank
 * @component
 */
const DeclinedPayment = ({ orderCode }: PropsWithChildren<PropsDeclinedPayment>): JSX.Element => {

  /** Estado Redux Tienda */
  const storeData = useAppSelector((state: RootState) => state.storeData) as IStore | null;
  /** Hook que contiene las dimensiones de la pantalla y maneja los componentes de acuerdo al resultado obtenido */
  const { width, maxLargeWidth }: ScreenSize = useScreenSize();
  /** Variable que define si es entorno mobile o desktop */
  const isMobile: boolean = width < maxLargeWidth;
  /**Variables de Entorno */
  const URL_IMAGES: string = process.env.REACT_APP_URL_IMAGES ?? '';
  const PHONE_NUMBER: string = storeData?.notificationsPhone?.number ?? '';
  /** Hook para generar una navegación dentro de la aplicación. */
  const navigate: NavigateFunction = useNavigate();
  /** Hook para trabajar con document location  */
  const location: Location = useLocation();

  /** Rutas URLs */
  const routesDirections = getRoutesDirections();

  /**Constantes de texto */

  const DECLINED_PAYMENT_IMAGE: string = `${URL_IMAGES}/client/declined-payment.png`;

  const ORDER_NUMBER_TEXT: string = translate('checkout.order_number_text');
  const DECLINED_PAYMENT_TEXT: string = translate('checkout.declined_payment_text');
  const DECLINED_PAYMENT_DESCRIPTION: string = translate('checkout.declined_payment_description').replace('PHONE_NUMBER', PHONE_NUMBER);
  const BUTTON_TEXT: string = translate('checkout.try_again');

  /**Renderizado del componente */
  return (
    <Container fluid className='px-0 bg-primary-5 mh-700-px'>
      <Row className='pt-4 px-3 g-0 d-flex justify-content-center  mh-600-px'>
        <Col lg={6} className='bg-primary-4 shadow rounded d-flex pt-3 flex-column '>
          <Col lg={12} className='d-flex justify-content-center mt-5'>
            <Col xs={11} lg={8} xxl={5}>
              <Col className='d-flex justify-content-center'>
                <Image
                  src={DECLINED_PAYMENT_IMAGE}
                  alt='gif'
                  onError={(e: React.SyntheticEvent<HTMLImageElement>) => {
                    e.currentTarget.src = ErrorImage;
                  }}
                />
              </Col>

              <Col className='pb-4 mb-2 d-flex text-center justify-content-center'>
                <span className={`text-secondary-1 fw-bold ${isMobile ? 'h3' : 'h2'}  `}>{DECLINED_PAYMENT_TEXT}</span>
              </Col>
              <Col className='pb-4 mb-2 d-flex text-center justify-content-center'>
                <span className={`text-secondary-1 fw-bold paragraph`}>{`${ORDER_NUMBER_TEXT} ${orderCode}`}</span>
              </Col>
              <Col className='d-flex  justify-content-justify '>
                <p className=' text-secondary-2 h5 text-center'>{DECLINED_PAYMENT_DESCRIPTION}</p>
              </Col>
              <Col>
                <Button
                  className='btn-primary-icon-standard w-100 mt-4 '
                  onClick={() => navigate(routesDirections.CART_ROUTE, { state: { originURL: location.pathname } })}>
                  {BUTTON_TEXT}
                </Button>
              </Col>
            </Col>
          </Col>
        </Col>
      </Row>
    </Container>
  );
};

export default DeclinedPayment;
